import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter, map, tap} from 'rxjs/operators';

import {EventBusPort} from '@platform/event-bus/domain/ports/event-bus.port';
import {AccountSelectedEvent} from '@shared/application/events/account/account-selected.event';
import {CartOpenedEvent} from '@platform/event-bus/domain/events/cart/cart-opened.event';
import {distinctUntilChanged} from "rxjs";

@Injectable({providedIn: 'root'})
export class PlatformOnAccountSelectedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);

  constructor() {
    this.eventBus
      .ofType(AccountSelectedEvent)
      .pipe(
        map((event) => event.account?.id),
        filter(Boolean),
        distinctUntilChanged(),
        tap((accountId) =>
          this.eventBus.publish(new CartOpenedEvent({accountId})),
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
